import { useEffect, useMemo, useState } from "react";
import { Option } from "../../common/commonSelect";
import useApi from "../useApi";
interface dataTypes {
  org_id: string;
  name: string;
  full_name:string;
  organization:string
  user_id: string;
}
export function useUserByOrg(organizationIds: string[]) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);

  const { callApi, loading, error } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];
    return dataList.map((d) => ({
      label: d?.full_name ?? "",
      value: d?.user_id ?? "",
    }));
  }, [dataList]);

  const fetchData = async () => {
    try {
      const orgId = organizationIds[0]; 
      const res = await callApi(
        undefined,
        `/api/v1/admin/auth/organizations/${orgId}/users`,
      );
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      console.error(err);
      setDataList([]);
    }
  };

  useEffect(() => {
    if (!organizationIds?.length) {
      setDataList([]);
      return;
    }
    fetchData(); 
  }, [organizationIds]);

  return { dataList, options, loading };
} 